// import essLocalApi from '../axios/esspLocalApi';
import essApi from "../axios/essApi";
import moment from "moment";
class TimesheetService {
  async getTimesheetsData(param) {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const fd = moment(firstDay).format("DD");
    const ld = moment(lastDay).format("DD");
    const m = moment(new Date()).format("MM");
    const y = moment(new Date()).format("YYYY");
    let sDate = fd + "-" + m + "-" + y;
    let eDate = ld + "-" + m + "-" + y;
    let startDate = param.startDate ? param.startDate : sDate;
    let endDate = param.endDate ? param.endDate : eDate;
    return Promise.resolve(essApi.get(`timesheet-by-user/${param.status}?startDate=${startDate}&endDate=${endDate}`));
  }

  async getAllocatedProject() {
    return Promise.resolve(essApi.get(`allocated-project-by-user`));
  }

  async getAllProjectByUser() {
    return Promise.resolve(essApi.get(`projects-by-user?myProject=true`));
  }

  async getAllProjectByAdmin() {
    return Promise.resolve(essApi.get(`projects-by-user?admin=true`));
  }

  async getUsersByProjectIdInDayWise(param) {
    return Promise.resolve(essApi.post(`users/userinfo-by-projectId`, param));
  }

  async getAllocatedProjectByUserManager(param) {
    return Promise.resolve(
      essApi.get(`allocated-project-by-user-for-manager/${param}`)
    );
  }

  async createNewTimesheet(param) {
    return Promise.resolve(essApi.post("timesheet", param));
  }

  async createTimesheetByUserManager(param) {
    return Promise.resolve(essApi.post("create-timesheet-for-manager", param));
  }

  async updateRecallTimesheet(param) {
    return Promise.resolve(essApi.post("timesheet-recall", param));
  }

  async updateMultipleRecallTimesheet(param) {
    return Promise.resolve(essApi.post("timesheet-recall-multiple", param));
  }

  async updateRequestRecallTimesheet(param) {
    return Promise.resolve(
      essApi.put("timesheet-recall-request-approve", param)
    );
  }

  async updateTimesheet(param) {
    return Promise.resolve(essApi.put(`timesheet/${param.id}`, param));
  }

  async saveTimesheetActivityData(param) {
    return Promise.resolve(essApi.post(`timesheet-project`, param));
  }

  async updateDraftData(param) {
    return Promise.resolve(essApi.put(`timesheet-project/${param.id}`, param));
  }

  async deleteDraftActivityData(param) {
    return Promise.resolve(essApi.delete(`timesheet-project/${param.id}`));
  }

  async updateDraftTimesheet(param) {
    return Promise.resolve(essApi.post(`update-timesheet`, param));
  }

  async deleteTimesheet(param) {
    return Promise.resolve(essApi.delete(`timesheet/${param}`));
  }

  /* Manager Team Data Services Start Here */
  async getTeamTimesheetsData() {
    return Promise.resolve(essApi.get(`timesheet-teaminfo-by-superiorId`));
  }


  async getUsersBySuperior(param) {
    if (param?.adminType == true) {
      return Promise.resolve(essApi.get(`users/userinfo-by-superiorId?admin=${param?.adminType}&page=${param?.pageNum}&size=${param?.pageSize}&lookup=${param?.lookup}`));
    } else if (param?.userId) {
      return Promise.resolve(essApi.get(`users/userinfo-by-superiorId?userId=${param?.userId}&page=${param?.pageNum}&size=${param?.pageSize}`));
    } else {
      return Promise.resolve(essApi.get(`users/userinfo-by-superiorId?page=${param?.pageNum}&size=${param?.pageSize}`));
    }
  }

  async getReviewimesheetsData(param) {
    return Promise.resolve(essApi.get(`user-id-timesheet/${param}`));
  }

  async approveRejectTimesheet(param) {
    return Promise.resolve(
      essApi.put(`manager-timesheet-approve-and-reject`, param)
    );
  }

  async approveRejectBulkTimesheet(param) {
    return Promise.resolve(
      essApi.put("manager-timesheet-approve-and-reject-in-bulk", param)
    );
  }
  /* Manager Team Data Services End Here */

  /* Manager Approval Timesheet List start */
  async getManagerRecentApprovalList() {
    return Promise.resolve(essApi.get(`my-recent-approval`));
  }
  /* Manager Approval Timesheet List end */

  /* Manager - Get all timesheets for approval start */
  async getAllTimesheetApprovals() {
    return Promise.resolve(essApi.get(`my-timesheet-approval`));
  }
  /* Manager - Get all timesheets for approval end */

  /* Update Timesheet Approval Start */
  async updateTmesheetApproval(param) {
    return Promise.resolve(essApi.put(`update-timesheet-approval`, param));
  }
  /* Update Timesheet Approval end */

  /*existing timesheet error start*/
  async existingTimesheetCheck(param) {
    return Promise.resolve(essApi.post("timesheet-by-date", param));
  }

  /* Update deallocation Start */
  async updateDeallocation(param) {
    return Promise.resolve(essApi.put(`de-allocation `, param));
  } /* Update te deallocation end */

  async getAllHolidays() {
    return Promise.resolve(essApi.get(`holiday-region`));
  }

  /* Get Approved Team Timesheet List start */
  async getApprovedTeamTimesheet(param) {
    return Promise.resolve(essApi.get(`timesheet-by-user-for-manager/${param.userId}/${param.status}?startDate=${param.startDate}&endDate=${param.endDate}`));
  }
  /* Get Approved Team Timesheet List end */

  /* Get Locked Team Timesheet List start */
  async getLockedTeamTimesheet(param) {
    return Promise.resolve(essApi.get(`timesheet-by-user-for-manager/${param.userId}/${param.status}?startDate=${param.startDate}&endDate=${param.endDate}`));
  }
  /* Get Locked Team Timesheet List end */

  /* Get Timesheet Team Invoice List start */
  async getTimesheetTeamInvoiceData(param) {
    return Promise.resolve(essApi.post("timesheet-teaminfo-invoice-data", param));
  }

  async getTimesheetTeamInvoiceExcelData(param) {
    return Promise.resolve(
      essApi.post("timesheet-teaminfo-invoice-data", param, {
        responseType: "arraybuffer",
      })
    );
  }
  /* Get Timesheet Team Invoice List end */

  /* Lock/Unlock Manager Team Invoice Timesheet start */
  async lockUnlockInvoiceTimesheet(param) {
    return Promise.resolve(
      essApi.put("manager-timesheet-lock-and-unlock-in-bulk", param)
    );
  }
  async dayWiseTimesheetData(param) {
    return Promise.resolve(essApi.post(`timesheet-user-data`, param));
  }

  async dateRangeCalendars(param) {
    return Promise.resolve(essApi.post(`approved-timesheet-data`, param));
  }

  /*get timesheet count for all status */
  async getTimesheetCountForAllStatus() {
    return Promise.resolve(essApi.get(`timesheet-count-for-all-status`));
  }
  /* Lock/Unlock Manager Team Invoice Timesheet end */

  // filterdate timesheet
  async filterTimeSheet(param) {
    return Promise.resolve(essApi.get("approved-timesheet-data", param));
  }

  async getReviewRecallTimesheet(param) {
    return Promise.resolve(essApi.get(`all-recalled-timesheets/${param.userId}`));
  }
  // async timesheetCompliance(month, year = new Date().getFullYear()) {
  //   return Promise.resolve(essApi.get(`timesheetCompliance?month=${month}&year=${year}`));
  // }
  async timesheetCompliance(param) {
    // let month = param.month;
    // let year= new Date().getFullYear();
    return Promise.resolve(essApi.get(`timesheetCompliance?page=${param.pageNum}&size=${param.pageSize}&month=${param.month}&year=${param.year}`));
  }
  async approveRejectRecalledTimesheet(param) {
    return Promise.resolve(
      essApi.put(`approve-reject-recalled-timesheet`, param)
    );
  }
  // filterdate team
  async filterTeamData(param) {
    return Promise.resolve(essApi.post(`users/team-filter`, param));
  }
  //delete multiple timesheet in draft
  async deleteAllTimesheet(param) {
    return Promise.resolve(essApi.post(`delete-multiple-timesheet`, param));
  }

  async checkEmployessFilledTimesheet(param) {
    return Promise.resolve(essApi.post(`timesheet-filled-validation`, param));
  }

  async getProjectByUserId(param) {
    return Promise.resolve(essApi.post(`/allocActivityGroupBYProject`, param));
  }

  async getConfigurationSettingData() {
    return Promise.resolve(essApi.get(`config_data`));
  }
  async getConfigurationSettingDataBySlug(param) {
    return Promise.resolve(essApi.get(`config_data/${param}`));
  }
  async getConfigurationSettingDataById(param) {
    return Promise.resolve(essApi.get(`config_data/${param}`));
  }
  async updateConfigurationSettingData(param) {
    console.log(param, "updateConfigurationSettingData")
    return Promise.resolve(essApi.put(`config_data/${param?.id}`, param));
  }
  
}
export default TimesheetService;
